import { useAtom } from 'jotai';
import { useCallback } from 'react';

import { newNotificationIndicatorAtom } from 'store/notifications/notifications.atom';

import { NotificationSeverity } from 'types/models/Notification';

export const useNewNotificationIndicator = () => {
  const [indicator, setIndicator] = useAtom(newNotificationIndicatorAtom);

  const resetNotificationIndicator = useCallback(() => {
    setIndicator(false);
  }, [indicator]);

  const setNewNotificationIndicator = useCallback(
    (severity: NotificationSeverity = NotificationSeverity.Info) => {
      if (indicator || severity !== NotificationSeverity.Error) {
        return;
      }
      setIndicator(true);
    },
    [indicator],
  );

  return {
    newNotificationIndicator: indicator,
    resetNotificationIndicator,
    setNewNotificationIndicator,
  };
};
